import { Chip, makeStyles, ChipProps, ThemeProvider } from '@material-ui/core'
import * as colors from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'
import { selectChip } from '../../services/theme'

const useStyles = (variant) => {
	const color = colors[variant] || 'purple'
	const style = {
		foreground: color[600],
		background: color[50]
	}
	if (variant === 'gray') {
		style.foreground = color[800]
		style.background = color[300]
	}
	if (variant === 'dangers' || variant === 'red') {
		style.background = color[10]
		style.foreground = color[500]
	}
	if (variant === 'warnings' || variant === 'yellow') {
		style.background = color[10]
		style.foreground = color[500]
	}
	if (variant === 'successes' || variant === 'green') {
		style.background = color[10]
		style.foreground = color[500]
	}
	if (variant === 'errors') {
		style.background = color[10]
		style.foreground = color[500]
	}

	return makeStyles(() => ({
		root: {
			backgroundColor: style.background,
			padding: '.75rem 0.5rem',
			fontFamily: 'Nunito',
			fontWeight: FONT_WEIGHTS.SemiBold,
			fontSize: '0.75rem',
			color: style.foreground,
			'& .MuiChip-label': {
				marginRight: 0
			},
			borderWidth: 0
		}
	}))
}

/**
 * A Material Chip with custom styling via skiptownvariant which uses the skiptown color palette.
 *
 * Purple is default skiptownvariant
 *
 * useThemeProvider is a fallback to our old chip styles and is here for backwards compatibility
 * @param {ChipProps & {skiptownvariant?: 'gray' | 'purple'| 'yellow' | 'red' | 'dangers' | 'warnings'| 'successes' | 'errors', useThemeProvider?: boolean}} props
 * @returns
 */
const StyledChip = (props) => {
	if (props.useThemeProvider) {
		return (
			<ThemeProvider theme={selectChip}>
				<Chip {...props} />
			</ThemeProvider>
		)
	}
	const classes = useStyles(props.skiptownvariant || 'purple')()
	return <Chip className={classes.root} {...props} />
}
export default StyledChip
